import React, { Suspense, useEffect } from 'react'
import { HashRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { CSpinner, useColorModes } from '@coreui/react'
import './scss/style.scss'
import { isAuthenticated } from './api/auth'

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'))
const Register = React.lazy(() => import('./views/pages/register/Register'))
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))
const RegistroPublico = React.lazy(() => import('./views/public/registro/RegistroPublico'))
const PoliticaDatos = React.lazy(() => import('./views/public/registro/PoliticaDatos'))
const SuscripcionPublica = React.lazy(
  () => import('./views/public/suscripciones/SuscripcionPublica'),
)
const isSubscriptionHost = window.location.hostname === 'suscripciones.consultapp.com.co'
// POC de videollamadas inactiva. La implementación se conserva en views/videollamadas.

const RequireAuth = () => {
  useLocation()
  return isAuthenticated() ? <DefaultLayout /> : <Navigate to="/login" replace />
}

const App = () => {
  const { isColorModeSet, setColorMode } = useColorModes('coreui-free-react-admin-template-theme')
  const storedTheme = useSelector((state) => state.theme)

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.href.split('?')[1])
    const theme = urlParams.get('theme') && urlParams.get('theme').match(/^[A-Za-z0-9\s]+/)[0]
    if (theme) {
      setColorMode(theme)
    }

    if (isColorModeSet()) {
      return
    }

    setColorMode(storedTheme)
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <HashRouter>
      <Suspense
        fallback={
          <div className="pt-3 text-center">
            <CSpinner color="primary" variant="grow" />
          </div>
        }
      >
        <Routes>
          {isSubscriptionHost && (
            <Route exact path="/" name="Suscripciones" element={<SuscripcionPublica />} />
          )}
          <Route exact path="/login" name="Login Page" element={<Login />} />
          <Route exact path="/register" name="Register Page" element={<Register />} />
          <Route exact path="/404" name="Page 404" element={<Page404 />} />
          <Route exact path="/500" name="Page 500" element={<Page500 />} />
          <Route exact path="/registro" name="Registro" element={<RegistroPublico />} />
          <Route exact path="/suscripcion" name="Mi suscripción" element={<SuscripcionPublica />} />
          <Route
            exact
            path="/politica-tratamiento-datos"
            name="Política de tratamiento de datos"
            element={<PoliticaDatos />}
          />
          <Route path="*" name="Menu" element={<RequireAuth />} />
        </Routes>
      </Suspense>
    </HashRouter>
  )
}

export default App
